import type { ControlBridgeQueueItem, ControlBridgeViewModel } from '../deriveViewModel';
import {
  collectItemIdKeys,
  itemIdMatchesSource,
  normalizeItemIdKey,
  type ItemIdMatchOptions,
} from '../../../utils/itemIdPlane';

export function queueItemsFromViewModel(vm: ControlBridgeViewModel): ControlBridgeQueueItem[] {
  const seen = new Set<string>();
  const out: ControlBridgeQueueItem[] = [];
  // Include organizerLoad: Personal Organizer lists rows past the Exo attention
  // 20-cap. Focus inject must find those ids or Exo keeps the prior selection.
  for (const item of [
    ...vm.eligibleWork,
    ...(vm.organizerLoad ?? []),
    ...vm.blockedWork,
    ...vm.openIssues,
    ...vm.waypoints,
    ...vm.guidanceTimeline,
    ...vm.guidanceWbsQueue,
    ...vm.recommendedFocus,
  ]) {
    const keys = collectItemIdKeys(item);
    const primary = normalizeItemIdKey(item.itemId);
    if (!primary) continue;
    if (keys.some((k) => seen.has(k))) continue;
    for (const k of keys.length ? keys : [primary]) {
      seen.add(k);
    }
    out.push(item);
  }
  return out;
}

export function findQueueItemById(
  items: ControlBridgeQueueItem[],
  itemId: string,
  options?: ItemIdMatchOptions
): ControlBridgeQueueItem | undefined {
  return items.find((item) => itemIdMatchesSource(itemId, item, options));
}

export function queueItemOrFallback(
  items: ControlBridgeQueueItem[],
  itemId: string,
  fallback: Partial<ControlBridgeQueueItem> & { title: string; statusPhrase: string },
  options?: ItemIdMatchOptions
): ControlBridgeQueueItem {
  return (
    findQueueItemById(items, itemId, options) ?? {
      ...fallback,
      itemId,
    }
  );
}
